// import 'hooper/dist/hooper.css'
import Vue from 'vue'
const consola = require('consola'); consola.level = process.env.CONSOLA_LEVEL;
import { mapGetters, mapMutations, mapActions } from 'vuex'

import domel from '~/components/domel'
// import RestImg from '~/components/rest-img'
// import RestString from '~/components/rest-string'
// import RestStringLink from '~/components/rest-string-link'
// import RestProp from '~/components/rest-prop'
// import RestRichText from '~/components/rest-rich-text'
// import RestPropLink from '~/components/rest-prop-link'
// import RestModel from '~/components/rest-model'
// import RestDate from '~/components/rest-date'
// import RestDateAdd from '~/components/rest-date-add'
// import RestReorderList from '~/components/rest-reorder-list'
// import RestListItemAdd from '~/components/rest-list-item-add'
// import RestItemAdd from '~/components/rest-item-add'
// import RestItemRemovable from '~/components/rest-item-removable'
import TextFx from '~/components/text-fx'
import HeroSection from '~/components/hero-section'
import svgSymbol from '~/components/svg-symbol'
import ctaArrow from '~/components/cta-arrow'
import Carousel from '~/components/carousel'
// import TagInput from '~/components/tag-input'


import HeaderMetaMixin from '~/mixins/header-meta'
import CourseDateUtils from '~/mixins/course-date-utils'
import Affix from '~/mixins/Affix'
import WheelPassthroughMixin from '~/mixins/scrollwheel-passthrough'
import InstructorModalMixin from '~/mixins/open-instructor-modal'


// import HeaderSidebar from '~/components/header-sidebar'
import AnnouncementsMixin from '~/mixins/announcements'
// import Quotes from '~/components/quotes'
import Accordion from '~/components/accordion'
import FaqList from '~/components/faq-list'


import Intersect from '~/components/vue-intersect'
import ScrollObserver from '~/components/scroll-observer-raf'
import LazyHydrate from 'vue-lazy-hydration';


// const makeWebP = require('~/src/utils/webp-path');

// import { SlickList, SlickItem } from 'vue-slicksort';
// import SortableHandle from '~/components/sortable-handle'
// import CollectionModal from '~/components/collection-modal'
// import { Carousel, Slide } from '~/lib/vue-carousel';
// import { Hooper, Slide } from 'hooper';

// this is how you can get the path of an image asset
// import pinSvg from '~/assets/svg/pin.svg'

const endsWith = require('lodash.endswith')
const uniqBy = require('lodash.uniqby');

// import yamlData from '~/assets/test.yaml'

// const page_slug = "/blended-learning";


export default {

	layout: 'courses',

	mixins: [HeaderMetaMixin, CourseDateUtils, Affix, WheelPassthroughMixin, AnnouncementsMixin, InstructorModalMixin],

	components:
	{
		LazyHydrate,

		// SlickList, SlickItem,
		// SortableHandle,

		ctaArrow,
		svgSymbol,
		TextFx,
		HeroSection,
		// Carousel, Slide,
		// Hooper, Slide,
		Carousel,

		// 'header-sidebar': HeaderSidebar,
		// Quotes,
		Intersect,
		ScrollObserver,
		Accordion,
		FaqList,
		// CollectionModal,
	},

	// this overrides the HeadMeatMixin
	// head: { bodyAttrs: { "class": ["page-blended-learning"] } },

	data()
	{
		return {
			bodyClasses: ["page-blended-learning"],

			//- responseData: null,
			pageLoaded: false,

			pageData: { block_list: [{}, {}, {}, {}, {}, {}, {}, {}, {}, ], course: null },
			// blocks: [{}, {}, {}, {}, {}, {}, {}, {}, {}, ],
			// course: null,

			// this is the list of upcoming courses
			courses: [],

			// this is the locales of the current page course
			pageCourseLocales: [],

			animsOnce: true,
			quoteIsVisible: false,

			heroSubtitleStyle: {
				opacity: 0
			},

			sidebarSubtextStyle: {
				transition: 'none',
				opacity: 0,
			},


			// showCollectionModal: true,
			//- courseData: null,
			currentSectionKey: 'key-benefits',
			carouselOffsetX: 0,
			prevTouchX: 0,

			// title: '',
			// meta: [],
			isEditingPage: false
		};
	},

	// async validate({ app, params, query, store })
	// {
	// 	const slug = '/course/' + (params.slug ? params.slug : '');
	// 	consola.debug('page-validate: ', slug)
	// 	// debugger;
	// 	return app.$apiGet('page-validate/',
	// 				{ slug, locale: params.lang } )
	// 		.then( result =>
	// 			{
	// 				consola.debug('page-validate result: ', result)
	// 				if (!result.data || result.data.status == 404)
	// 					return false
	// 				else
	// 					return true
	// 			} )
	// 		.catch( error =>
	// 			{
	// 				console.error(`page-validate error : [${error.response.status}] `, error.response.statusText)
	// 				// console.error(`page-validate error : `, error.response)
	// 				return false;
	// 			})

	// 	// try
	// 	// {
	// 	// 	const result = await app.$apiGet('page-validate/',
	// 	// 								{ slug, locale: params.lang } )
	// 	// 								// { locale: store.getters.lang } )
	// 	// 	consola.debug('page-validate result: ', result)
	// 	// 	if (!result.data || result.data.status == 404)
	// 	// 		return false
	// 	// 	else
	// 	// 		return true
	// 	// }
	// 	// catch (error)
	// 	// {
	// 	// 	// debugger;
	// 	// 	console.error(`page-validate error : [${error.response.status}] `, error.response.statusText)
	// 	// 	// console.error(`page-validate error : `, error.response)
	// 	// 	return false;
	// 	// }
	// },

	async asyncData({app, params, store, error, req, route})
	{
		// const lang = params.lang;
		const lang = 'el';
		store.dispatch('setLang', { lang: lang });
		store.dispatch('setDeviceWidthFromUserAgent');

		const page_slug = route.path.replace('/edit','');//.slice(3);
		const slug = page_slug;

		return Promise.all([
							app.$apiGet('page-slug/', { slug, site_id: 2, locale: lang } ),
							app.$apiGet('course', { locale: lang, is_published: 1 } ),
					])
			.then( list =>
			{
				consola.debug('asyncData list.length: ', list.length);
				// consola.debug('asyncData typeof list[0]: ', typeof list[0]);
				consola.debug('asyncData keys list[1]: ', Object.keys(list[1]));
				const pageData = list[0].data[0];
				if (pageData.locale)
				{
					consola.debug('page locale: ', pageData.locale )
					store.commit('set_lang', { lang: pageData.locale })
				}


				const menu = pageData.menu && pageData.menu.json || [];
				store.commit('setPageMenu', menu);

				const footer = pageData.footer && pageData.footer.json || [];
				store.commit('setPageFooter', footer);

				return {
							pageData,
							// blocks: list[0].data[0].block_list,
							// course: list[0].data[0].course,
							courses: list[1].data
						}
			} )
			.catch( error =>
			{
				consola.debug(`blended-learning.js[221] error: `, error)
				return {};
			})

	},

	watch:
	{
		// lang(newVal, prevVal)
		// {
		// 	consola.debug('language was changed, retrieving new data...')

		// 	this.fetchData()
		// }
		isEditingPage(newVal)
		{
			if (newVal)
			{
				// this.currentQuoteIdx = 0;

				// this.fetchCourseTaxonomies();
			}
		},

		pageLoaded(newVal)
		{
			// setTimeout( ()=>
			// {
			// 	if (newVal)
			// 		this.sidebarClasses = [];
			// },
			// 1000 )
		},
	},

	computed:
	{
		// ...mapGetters(['getString', 'lang', 'langShort', 'allLanguages', 'windowWidth', 'isMobile', 'isTablet', 'isDesktop']),
		...mapGetters([/*'isEditingPage',*/ 'getString', 'lang', 'langShort', 'allLanguages', 'adminPanelRef', 'windowWidth', 'isMobile', 'isTablet', 'isTabletOrBigger', 'isLargerThanTabletLandscape', 'isLaptop', 'isLaptopOrBigger', 'isDesktop', 'windowWidth', 'scrollTop', 'scrollBottom']),

		blocks()
		{
			// debugger
			return this.pageData.block_list || [];
		},

		// course()
		// {
		// 	let block = this.pageData.course;
		// 	if (!block)	debugger;
		// 	return block;
		// },

		carouselStyle()
		{
			return `transform: translate3d(${this.carouselOffsetX}px, 0px, 0px)`;
		},

		headBlock()
		{
			let block = this.blocks.filter(x => x.block_type == 'head')[0];
			if (!block)	debugger;
			return block;
		},

		trainingBlock()
		{
			let block = this.blocks.filter(x => x.block_type == 'training methods')[0];
			if (!block)	debugger;
			return block;
		},

		attendanceBlock()
		{
			let block = this.blocks.filter(x => x.block_type == 'attendance')[0];
			if (!block)	debugger;
			return block;
		},

		instructorBlock()
		{
			let block = this.blocks.filter(x => x.block_type == "instructors")[0];
			if (!block)	debugger;
			return block;
		},

		publishedInstructors()
		{
			return this.publishedOnly(this.instructorBlock.extra_data);
		},


		platformBlock()
		{
			let block = this.blocks.filter(x => x.block_type == "education platform")[0];
			if (!block)	debugger;
			return block;
		},

		applicationBlock()
		{
			let block = this.blocks.filter(x => x.block_type == "practical application")[0];
			if (!block)	debugger;
			return block;
		},

		courseBlock()
		{
			let block = this.blocks.filter(x => x.block_type == 'courses' && x.block_id!=907 )[0];
			if (!block)	debugger;
			return block;
		},

		courseListBlock()
		{
			let block = this.blocks.filter(x => x.block_type == 'courses' && x.block_id==907 )[0];
			if (!block)	debugger;
			return block;
		},

		// courseBlock()
		// {
		// 	return this.blocks.filter(x => x.block_type == 'courses' && x.block_id!=907)[0];
		// },

		// courseListBlock()
		// {
		// 	return this.blocks.filter(x => x.block_type == 'courses' && x.block_id==907 )[0];
		// },


		// title()
		// {
		// 	return this.course ? this.course.title : (this.getString('Course') || 'Course');
		// },

		meta()
		{
			return (this.padeData && this.pageData.meta_pairs) ? this.pageData.meta_pairs : [];
		}
	},

	// this is called when the children have been mounted and the component is ready
	mounted()
	{
		consola.debug('blocks:', this.blocks)

		// if (this.course && this.course.format_list.length)
		// {
		// 	// NOTE: for some reason duplicated entries are fetched from the DB
		// 	this.course.format_list = uniqBy(this.course.format_list, 'id');
		// }
		consola.debug('courses:', this.courses)

		this.$store.dispatch('setDeviceWidthFromWindow');
		// consola.debug('response: ', this.responseData)
		// this.$apiLoadCourseData('masterclass-in-translation').then((result)=>
		// {
		// 	consola.debug('result: ', result);
		// })
		// .catch((error)=>
		// {
		// 	console.error(error);
		// })

		// consola.debug('yaml test: ', yamlData);
		// consola.debug('course: ', this.course);
		consola.debug('pageData: ', this.pageData);
		// consola.debug('$meta().refresh(): ', this.$meta().refresh() )
		// consola.debug('courseData: ', JSON.stringify(this.courseData) );
		// this.$eventBus.$on( 'rest:response', this.updateData )
		this.registerEvents();

		this.$nextTick( ()=>
		{
			setTimeout( ()=>
			{
				this.pageLoaded = true;
				if ( this.$refs.sidebar )
					this.$refs.sidebar.selected_idx = 0;
			}, 10 )
		} )

		this.heroSubtitleStyle.opacity = 0;

		setTimeout(
			() => {
				this.heroSubtitleStyle.opacity = 1;
				consola.debug('heroSubtitleStyle.opacity: ', this.heroSubtitleStyle.opacity)
			},
			1000
		)

		// this.isEditingPage = this._name == "<CorporateEdit>";
		this.isEditingPage = endsWith(this.$vnode.key, 'edit');

		this.$store.commit('setEditingPage', { editing: this.isEditingPage })

		// this.$meta().refresh();
	},

	beforeDestroy()
	{
		this.unregisterEvents()
	},

	methods:
	{
		// makeWebP(path)
		// {
		// 	reutrn makeWebP(path)
		// },

		registerEvents()
		{
			// if ( typeof window !== 'undefined' )
			// {
			// 	this.resizeCallback = () => this.onWindowResize()
			// 	window.addEventListener('resize', this.resizeCallback )
			// }
			// this.$root.$on( 'show-quote-form', this.onShowQuoteForm )
			this.$eventBus.$on( 'rest:response', this.updateData )
			this.$eventBus.$on( 'set-page-data', this.setPageData )
			this.$eventBus.$on( 'set-course-locales', this.setCourseLocales )
		},

		unregisterEvents()
		{
			// if ( typeof window !== 'undefined' )
			// {
			// 	if (this.resizeCallback)
			// 		window.removeEventListener('resize', this.resizeCallback )
			// }
			// this.$root.$off( 'show-quote-form', this.onShowQuoteForm )
			this.$eventBus.$off( 'rest:response', this.updateData )
			this.$eventBus.$off( 'set-page-data', this.setPageData )
			this.$eventBus.$off( 'set-course-locales', this.setCourseLocales )
		},

		updateData(modelResponse)
		{
			this.fetchData()
		},

		setPageData(data, courses)
		{
			consola.debug('setPageData')

			let scrollY = 0;
			if (typeof window !=='undefined')
				scrollY = document.documentElement.scrollTop || window.pageYOffset || document.body.scrollTop;

			this.pageData = data;
			let menu = this.pageData.menu && this.pageData.menu.json || [];
			this.$store.commit('setPageMenu', menu);

			const footer = this.pageData.footer && this.pageData.footer.json || [];
			this.$store.commit('setPageFooter', footer);

			consola.debug('course: ', this.course)
			// this.blocks = this.pageData.block_list;

			if (courses)
				this.courses = courses;

			if (typeof window !=='undefined')
			{
				setTimeout( ()=>
				{
					if (document.documentElement.scrollTop)	document.documentElement.scrollTop = scrollY;
					if (window.pageYOffset)					window.pageYOffset = scrollY;
					if (document.body.scrollTop)			document.body.scrollTop = scrollY;
				}, 0);
			}
		},

		setCourseLocales(list)
		{
			consola.debug('setCourseLocales')
			this.pageCourseLocales = list;
		},

		blockIndex(block)
		{
			for (let i = 0; i < this.blocks.length; i++)
			{
				if (block.block_type == this.blocks[i].block_type)	return i;
				if (block == this.blocks[i])	return i;
			}

			return null;
		},

		printEvent(event)
		{
			consola.debug('print event ', event)
		},

		fetchData()
		{
			this.$nuxt.$loading.start();
			// get the last path element
			// const slug = window.location.pathname.replace('/edit', '').split('/').reduce( (_, x) => x );
			const page_slug = this.$route.path.replace('/edit','');//.slice(3);
			const slug = page_slug;

			this.$apiGet('page-slug/', { slug,  site_id: 2, locale: this.lang } )
				.then( (result) =>
				{
					consola.debug('Object.keys(result): ', Object.keys(result) );
					consola.debug('result.status: ', result.status );
					consola.debug('result.statusText: ', result.statusText );
					consola.debug('params.slug: ', slug);
					// consola.debug('result: ', result);

					if (this.course)
						for (let item of result.data[0].course.dates)
							item.delete = false;

					this.pageData = result.data[0]
					// this.blocks = result.data[0].block_list
					// this.course = result.data[0].course
					consola.debug('pageData: ', result.data[0])
					// consola.debug('course: ', result.data[0].course)

				})
				.catch( (error) =>
				{
					console.error('_slug fecthData error: ', error)
				} )
				.finally( () =>
				{
					this.$nuxt.$loading.finish();
				})
		},

		revealHead()
		{
			// sample methods function
		},

		publishedOnly(list)
		{
			if (!list || !Array.isArray(list))	return [];
			return list.filter(x => (typeof x.is_published=='undefined' || !!x.is_published)) || [];
		},

		addInstructor(obj, prop)
		{
			this.$eventBus.$emit('instructor:open', {url: 'instructor'})
			this.$eventBus.$once('instructor:selected', (result)=>
			{
				if ( !result )
					return;

				consola.debug('instuctor selected: ', result)
				obj[prop] = [ ...obj[prop], { ...result.item } ];
				// this.is_dirty = true;
				// this.asyncCommit()
			})
		},

		upcomingDate(list)
		{
			if (!list)	return null;

			// consola.debug(list)
			const now = Date.now();
			for (let i = 0; i < list.length; i++)
			{
				// let timestamp = parseInt(list[i].date) ;//* 1000;
				let timestamp = new Date(list[i].date).getTime() ;//* 1000;
				if (timestamp >= now)
				{
					let date = new Date( timestamp );
					return date;
					// let date = new Date( parseInt(list[i].date) * 1000 );

				}
			}

			return null;
		},

		date(num)
		{
			if (!num)	return null;
			return new Date( num )
			// return new Date( parseInt(num) )
		},

		year(date)
		{
			if (!date)	return '';
			return date.getFullYear()
		},

		short_year(date)
		{
			if (!date)	return '';
			return (date.getFullYear()+'').slice(-2)
		},

		month(date)
		{
			if (!date)	return '';
			return new Intl.DateTimeFormat(this.lang, { month: 'long' }).format( date )
			// return new Intl.DateTimeFormat(this.lang, { month: 'long' }).format( date.getMonth() )
		},

		short_month(date)
		{
			if (!date)	return '';
			return new Intl.DateTimeFormat(this.lang, { month: 'short' }).format( date )
			// return new Intl.DateTimeFormat(this.lang, { month: 'long' }).format( date.getMonth() )
		},

		day(date)
		{
			if (!date)	return '';
			return date.getDate()
		},



		onPanHorizontal(event)
		{
			// consola.debug('onPanHorizontal: ', event)
			this.carouselOffsetX = this.prevTouchX + event.deltaX;
			consola.debug('carouselOffsetX: ', this.carouselOffsetX)
		},

		onPanStart(event)
		{
			consola.debug('onPanStart: ', event)
			this.prevTouchX = this.carouselOffsetX;
		},

		onPanEnd(event)
		{
			consola.debug('onPanEnd: ', event)
		},

		onPanMove(event)
		{
			consola.debug('onPanMove: ', event)
		},

	}
}
